import React from 'react';

import {
  SearchSortBy as DefaultSearchSortBy,
} from '@uncinc/react-searchkit';

import { APP_OPTIONS } from '../../config/constants';

const SearchSortBy = () => {

  return (
    <div className="SearchSortBy">
      <DefaultSearchSortBy
        className="SearchAllContent__SortBy"
        isSearchable={false}
        inputType="radios"
        items={[
          { label: 'Datum', value: `${APP_OPTIONS.parameters.searchkitIndexAllContent}_created_desc` },
          { label: 'Relevantie', value: APP_OPTIONS.parameters.searchkitIndexAllContent },
        ]}
      />
    </div>
  );
};

export default SearchSortBy;
